import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

export type LogoutFn = () => Promise<void>;

export function initLogoutFn({ dependencies }: DomainInitPayload): LogoutFn {
    const { clientSdk, microservicesSdk } = dependencies;
    return async () => {
        try {
            /**
             * MS logout call removes AUTH_TOKEN cookie,
             * therefore we must anon log in into clientSdk post MS logout.
             */
            try {
                await microservicesSdk.domains.authenticate.logout({
                    source: 'PHX',
                });
            } catch (error: any) {
                /**
                 * Do not surface SMS logout error
                 */
            }
            // TODO: do we need to do anything with clearing the AUTH_TOKEN cookie here?
            await clientSdk.user.anonymousLogin(true);
            // TODO: add analytics for successful logout
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
